export const mapDataToQueryString = data =>
  Object.keys(data)
    .map(key => (data[key] ? `${key}=${data[key]}` : ""))
    .filter(item => item && item.length > 0)
    .join("&");
